'use client'

import { useState, useRef, useEffect } from "react";
import type {DZTypes} from "@dealerzone/libs";

export function VehicleYoutubeEmbed({ vehicle } : { vehicle: DZTypes.Vehicle }) {

    const embedUrl = vehicle.video?.youtube_embed;

    const [isVertical, setIsVertical] = useState(false);
    const iframeRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        const iframe = iframeRef.current;
        if (!iframe) return;

        iframe.addEventListener("load", () => {
            try {
                const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
                if (!iframeDoc) return;

                const videoEl = iframeDoc.querySelector("video") as HTMLVideoElement | null;
                if (videoEl) {
                    const { videoWidth, videoHeight } = videoEl;
                    setIsVertical(videoHeight > videoWidth);
                }
            } catch {
                // Cross-origin — cannot read dimensions directly
                // You'll need to know orientation from API or metadata
            }
        });
    }, []);

    if(!embedUrl) {
        return null;
    }

    return (
        <div className={isVertical ? "mt-10 aspect-[9/16]" : "mt-10 aspect-video"}>
            <iframe
                ref={iframeRef}
                className="w-full self-stretch md:min-h-96"
                src={embedUrl}
                title={vehicle.name+" Video"}
                aria-hidden="true"
            />
        </div>
    )
}
